<template>
	<div class="card mb-0 shadow">
		<div class="card-body">
			<div class="tab-content">
				<div class="animate__animated animate__fadeIn">
					<div class="row">
						<div class="col-12">
							<h4 class="font-weight-bold">Anexos</h4>
						</div>
						<form-file
							@submit="submitFile"
							multiple
							btn-text="Iniciar"
							label="Enviar anexo(s)"
							:progress="progressCompleted"
						/>
						<load mode="table" v-if="loadAnexos" />
						<div v-else class="col-12">
							<anexos :anexos="acompanhamento.anexos" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["acompanhamento"],
	data() {
		return { files: {}, progressCompleted: 0, loadAnexos: false };
	},
	methods: {
		submitFile(files) {
			this.files = files;
			let formData = new FormData();

			if (this.files.length > 0 && this.files.length != undefined) {
				for (const i of Object.keys(this.files)) {
					formData.append("anexos[]", this.files[i]);
				}
			} else {
				formData.append("anexos", this.files);
			}

			formData.append("id", this.acompanhamento.id);

			this.loadAnexos = true;
			axios
				.post(`api/dashboard/acompanhamento/upload`, formData, {
					header: { "Content-Type": "multipart/form-data" },
					onUploadProgress: (event) => {
						let progress = Math.round((event.loaded * 100) / event.total);
						this.progressCompleted = progress;
					},
				})
				.then((response) => {
					this.acompanhamento.anexos = response.data;
					this.$snack.success({
						button: false,
						text: "Upload realizado com sucesso.",
					});
				})
				.finally(() => {
					this.progressCompleted = 0;
					this.files = [];
					this.loadAnexos = false;
				});
		},
	},
};
</script>
